import SurveyValue from './SurveyValue'

// NOTE: These numbers reflect what is stored on the server.
export const JACKET_LENGTHS = {
  EXTRA_SHORT: 'XS',
  SHORT: 'S',
  REGULAR: 'R',
  LONG: 'L',
  EXTRA_LONG: 'XL',
}

// NOTE: Do not use class directly except to check for type!
export default class JacketLength extends SurveyValue {
  toLabel() {
    switch (this.key) {
      case JACKET_LENGTHS.EXTRA_SHORT:
        return 'Extra Short (XS)'
      case JACKET_LENGTHS.SHORT:
        return 'Short (S)'
      case JACKET_LENGTHS.REGULAR:
        return 'Regular (R)'
      case JACKET_LENGTHS.LONG:
        return 'Long (L)'
      case JACKET_LENGTHS.EXTRA_LONG:
      default:
        return 'Extra Long (XL)'
    }
  }

  toSummaryLabel() {
    return this.toKey()
  }

  toReadable() {
    return this.toKey()
  }

  static keyToObject(key) {
    return new JacketLength(key)
  }
}
